import React, { useEffect, useState, useContext } from 'react';
import Helmet from 'react-helmet';

import Layout from '../../components/layout';

import PAGE_HEADER_ITEMS from './data/interest-free-header.json';
import CarouselHeader from '@/components/Carousel/carouselHeader';
import HereToHelpSection from './_hereToHelp';
import FindByCategorySection from './_findByCategory';
import { PageContext } from '@/context/PageContext';
import { CONTENTFUL_COMPONENTS } from '@/utils/constants';
import HeroBanner from '@/components/lab-components/HeroBanner';
import { useSetState } from '@/utils/hooks';
import '@/components/PageLayout/pageHeader.css';
import { AnalyticsContext } from 'latitude-analytics';
import ImportantInformationSection from './_importantInformation';

const ANY_VALUE = '*';

function FindByCategoryPage(props) {
  const [categoryName, setCategoryName] = useState(ANY_VALUE);

  useEffect(() => {
    let result = ANY_VALUE;
    if (window?.location?.search) {
      const queryParameters = new URLSearchParams(window.location.search);
      const name = queryParameters.get('c');
      if (name) {
        result = name;
      }
    }
    setCategoryName(result);
  }, []);

  /** Contentful Data */
  const contentfulPageData = useContext(PageContext);
  const state = contentfulPageData?.updatedBody || {};
  /** - END - */
    
  const [analytics] = useContext(AnalyticsContext);
  useEffect(()=> {
    const sourceCode = localStorage.getItem('source_code') || 'IDAAA';
    // adding pageData to analytics
    analytics.pageData = {
      page_pageTitle: 'find-by-category',
      page_pageType: 'information-page',
      page_siteSection: 'interest-free',
      page_siteSubsection: 'find-by-category',
      product_productid: ["CCAUGOM","CCAUGEM"],
      application_sourcecode: sourceCode || 'IDAAA'
    };  
  },[])

  return (
    <Layout location={props.location}>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.latitudefinancial.com.au/interest-free/find-by-category/"
        />
        <title>Find Interest Free Offers By Retail Category | Latitude</title>
        <meta name="description" content="Browse Interest Free offers on furniture, travel & experiences, appliances, fashion and more. Enjoy the flexibility of Interest Free payment plans. Apply now" />
      </Helmet>

      <main className="navigation-spacer" css="background-color: #f8f8f8;">
        {state?.heroBannerData?.[0] ? (
          <HeroBanner {...state?.heroBannerData[0]} />
        ) : (
          <CarouselHeader HEADER_ITEMS={PAGE_HEADER_ITEMS} />
        )}

        <FindByCategorySection
          id="find-an-offer"
          currentCategory={categoryName}
        />
        <HereToHelpSection id="here-to-help" />
         <ImportantInformationSection
            contentfulData={state?.importantInfoData?.[0]}
          />
      </main>
    </Layout>
  );
}

export default FindByCategoryPage;
